import styled from 'styled-components';

export const StyledSpan = styled.span`
  font-weight: bolder;
`;

export const ProviderContentWrapper = styled.div<{
  errorPresent: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  ${props => !props.errorPresent && `margin-top: 24px`}
`;

export const BadgeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-self: flex-end;
  align-items: center;
  padding-top: 24px;
  /* The badge SVG uses currentColor. background-inverse is brand green in
     light and white in dark, which is what Figma shows for the wordmark. */
  color: var(--background-inverse);
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
